export const queries = [
    {
        id:1,
        question:'How to Customize Gifts and Frames ?',
        answer:'Easily customize your gift or frame by uploading your chosen image through our platform. Our advanced editing tools will ensure a flawless print, transforming your cherished memory into a stunning masterpiece.',
    },
    {
        id:2,
        question:'How to Process Payments ?',
        answer:'We offer a range of secure payment options to cater to your preferences. You can conveniently pay through network banking, UPI (Unified Payments Interface), QR codes, and other trusted methods. Choose the one that suits you best and enjoy a seamless payment experience.',
    },
    {
        id:3,
        question:'How to Track Shipping Order ?',
        answer:' To track your order, you will receive a unique tracking code through SMS. Alternatively, you can log in to your profile on our website and navigate to the "Track Orders" section. Enter the provided tracking code to access real-time updates on your order`s status and delivery progress. For easy navigation, you can find the "Track Orders" option in the footer section of our website.',
    },
    {
        id:4,
        question:'How to Get Help from Creative Carts ?',
        answer:'  You can seek help by sending us an email at support@creativecarts.com with your query, and our dedicated team will promptly respond with the required assistance.Also, you can reach out to our customer service team by dialing the phone number provided in the footer section of our website. Our friendly representatives will be delighted to address any concerns or questions you may have.',
    },
    {
        id:5,
        question:'What is Creative Carts',
        answer:'Explore more about our contents on about page and footer below ',
    }
]